import { SmartReplyPromptPreset } from '@copilot/common/hooks/smartReply/smartReplyPromptPresets/smartReplyPromptTypes';
import { PromptMenu } from './promptMenu';

const CUSTOM_OPTION = 'customEdit';

const customPromptEditItem = {
    key: CUSTOM_OPTION,
    label: 'Custom Edit',
};

/**
 * Interface for Edit Flow Dropdown Props
 */
export type EditFlowDropdownPropsType = Readonly<{
    /**
     * Prompts we want to display
     */
    prompts: SmartReplyPromptPreset[];
    /**
     * Callback when the user select a preset prompt to generate
     */
    onSelectPreset: (key: string) => void;
    /**
     * Callback to update whether the user is writing a custom prompt to edit
     */
    setIsWritingCustomPrompt: (isWritingCustomPrompt: boolean) => void;
    /**
     * Callback to update whether the user is writing a custom edit
     */
    setIsEditing: (isEditing: boolean) => void;
}>;

/**
 * [Presentational] Dropdown to represent the edit flow of smart reply
 * @param props
 */
export function EditFlowDropdown({
    prompts,
    onSelectPreset,
    setIsWritingCustomPrompt,
    setIsEditing,
}: EditFlowDropdownPropsType) {
    return (
        <PromptMenu
            prompts={prompts}
            customPrompt={customPromptEditItem}
            selectable={false}
            onClick={({ key }) => {
                if (key === CUSTOM_OPTION) {
                    setIsWritingCustomPrompt(true);
                    setIsEditing(true);
                } else {
                    onSelectPreset(key);
                }
            }}
        />
    );
}
